<template>
  <f7-page>
    <f7-navbar back-link="back">
      <f7-nav-title>
        <navbar-center v-if="currentDraft">
          <div slot="title">菜單發佈</div>
          <div slot="subtitle">{{ currentDraft.title }}</div>
        </navbar-center>
      </f7-nav-title>
    </f7-navbar>

    <f7-list>
      <f7-list-item title="發佈至" group-title />
      <f7-list-item
        v-for="(store, index) in stores"
        :key="`release-stores-${index}`"
        radio
        :value="store.id"
        :title="`${store.name}${store.branch === null ? '' : store.branch}`"
        :after="storeId === store.id ? '目前店家' : ''"
        name="stores"
        :checked="targetStoreId === store.id"
        @change="setSelectedStoreId($event.target.value)" />
    </f7-list>

    <f7-list v-if="menuInfos">
      <f7-list-item title="更新版本或新增至" group-title />
      <f7-list-item
        v-if="menuInfos.length === 0"
        radio
        value="main"
        title="主要菜單"
        after="尚未發佈任何版本"
        name="menus"
        :checked="targetVariation === 'main'"
        @change="targetVariation = $event.target.value" />
      <f7-list-item
        v-for="(menuInfo, index) in menuInfos"
        :key="`release-stores-variations-${index}`"
        radio
        :value="menuInfo.variation"
        :title="menuInfo.variation"
        name="menus"
        :checked="targetVariation === menuInfo.variation"
        @change="targetVariation = $event.target.value"
        >
        <f7-input type="text" placeholder="例如: main" :defaultValue="menuInfo.variationTitle" @input="variationMenuTitles[index].variationTitle = $event.target.value" clear-button />
      </f7-list-item>
      <!-- <f7-list-item
        v-else
        v-for="(menuInfo, index) in menuInfos"
        :key="`release-stores-variations-${index}`"
        radio
        :value="menuInfo.variation"
        :title="menuInfo.variationTitle"
        :after="`目前版本: ${menuInfo.version}`"
        name="menus"
        :checked="targetVariation === menuInfo.variation"
        @change="targetVariation = $event.target.value" /> -->
      <f7-list-item radio name="menus" title="新增" :checked="targetVariation === '$new'" @change="targetVariation = '$new'" />
    </f7-list>
    <div v-else style="display: flex; justify-content: center;">
      <f7-preloader />
    </div>
    <f7-list v-if="targetVariation === '$new'" inline-labels no-hairlines-md>
      <f7-list-item ref="newMenuVariationId">
        <f7-label>菜單 ID</f7-label>
        <f7-input type="text" placeholder="例如: main" :value="newMenuVariationId" @input="newMenuVariationId = $event.target.value" @focus="onFocus('newMenuVariationId')" clear-button />
      </f7-list-item>
      <f7-list-item ref="newMenuTitle">
        <f7-label>菜單名稱</f7-label>
        <f7-input type="text" placeholder="例如: 主要菜單" :value="newMenuTitle" @input="newMenuTitle = $event.target.value" @focus="onFocus('newMenuTitle')" clear-button />
      </f7-list-item>
    </f7-list>

    <f7-button fill raised style="margin: 10%;" @click="releaseMenu">確認發佈</f7-button>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NavbarCenter from '@/common/components/NavbarCenter'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      targetStoreId: this.storeIdProp,
      targetVariation: this.menuDraftVariationProp,
      menuInfos: null,
      newMenuVariationId: 'main',
      newMenuTitle: '主要菜單',
      variationMenuTitles: [], // 一開始存放所有 menu title
      editMenuTitle: []
    }
  },
  async created () {
    await this.getAllUserStores(this.uid)
    await this.setStore(this.storeIdProp)
    if (!this.currentDraft || this.currentDraft.variation !== this.menuDraftVariationProp) {
      this.setCurrentDraft(null)
      await this.getMenuDraft(this.menuDraftVariationProp)
    }
    const { data: menuInfos } = await storeClient.get(`/stores/${this.storeIdProp}/menus/releaseVariations`)
    this.menuInfos = menuInfos
    this.newMenuVariationId = this.menuDraftVariationProp
    this.newMenuTitle = this.currentDraft.title

    this.variationMenuTitles = this.menuInfos.map(menuInfo => {
      return {
        variation: menuInfo.variation,
        variationTitle: menuInfo.variationTitle
      }
    })
  },
  computed: {
    ...mapState('userModule', ['uid', 'stores']),
    ...mapState('menuDraftModule', ['currentDraft']),
    ...mapGetters(['storeId'])
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('menuDraftModule', ['setCurrentDraft', 'getMenuDraft']),
    ...mapActions('menuModule', ['getMenuVariations']),
    ...mapActions('userModule', ['getAllUserStores']),
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    async setSelectedStoreId (storeId) {
      this.targetStoreId = storeId
      const { data: menuInfos } = await storeClient.get(`/stores/${storeId}/menus/releaseVariations`)
      this.menuInfos = menuInfos
    },
    releaseMenu () {
      const data = this.targetVariation === '$new'
        ? {
          targetStoreId: this.targetStoreId,
          targetVariation: this.newMenuVariationId,
          targetTitle: this.newMenuTitle
        } : {
          targetStoreId: this.targetStoreId,
          targetVariation: this.targetVariation,
          targetTitle: this.menuInfos.length === 0 ? '主要菜單' : this.variationMenuTitles.find(item => this.targetVariation === item.variation).variationTitle
          // targetTitle: this.menuInfos.length === 0 ? '主要菜單' : this.menuInfos.find(m => this.targetVariation === m.variation).variationTitle
        }
      // TODO: 沒有儲存前不能發布
      this.$f7.dialog.confirm(`是否發佈 "${this.currentDraft.title}" 至 ${data.targetStoreId}: ${data.targetVariation} (${data.targetTitle})`, '發佈菜單', async () => {
        this.$f7.dialog.progress('正在發佈菜單，請稍待...')
        const timoutId = setTimeout(() => {
          this.$f7.dialog.close()
          this.$f7.dialog.alert('請檢查網路狀況', '無法發佈菜單')
        }, 30000)
        try {
          await storeClient.post(`/stores/${this.storeIdProp}/menus/drafts/${this.menuDraftVariationProp}/release`, data)
          this.getMenuVariations() // 要更新首頁的版本號
          this.$f7.dialog.alert('已發佈', '成功', () => {
            this.$f7router.back()
          })
        } catch (e) {
          console.error(e)
          this.$f7.dialog.alert('請檢查網路狀況', '無法發佈菜單')
        } finally {
          clearTimeout(timoutId)
          this.$utils.nextFrame(() => this.$f7.dialog.close())
        }
      })
    }
  },
  components: {
    NavbarCenter
  }
}
</script>
